import React from "react";
import InstagramFeedPreview from "./InstagramFeedPreview";
import InstagramStoryPreview from "./InstagramStoryPreview";
import MediaProductTypeDropdown from "./components/MediaProductTypeDropdown";
import usePostGenerator from "utils/hooks/usePostGenerator";
import MoreOptions from "./components/MoreOptions";
import { getNetworkValidationIndex } from "utils/hooks/usePostValidator";

const InstagramPreview = (props) => {

    const {
        isEditable,
        onDeleteNetworkPost,
        onCreateNetworkPost,
        onPreferencesEdit,
        onCoverEdit,
        allPosts,
        postIndex,
        isSimpleView // Add this line
    } = props;

    const network = "instagram";
    const { generatePostWithNewMediaProductType } = usePostGenerator();


    const handleOnMediaProductTypeChange = (media_product_type) => {
        const postToCopy = allPosts?.[postIndex];
        const newPost = generatePostWithNewMediaProductType(postToCopy, network, media_product_type);
        !!onCreateNetworkPost && onCreateNetworkPost({...newPost}, true);
    }
    
    return (<>
        {!isSimpleView && (
            <div className="flex items-stretch w-full">
                <MediaProductTypeDropdown 
                    post={props?.[0] || props}
                    isEditable={isEditable}
                    onChange={(media_product_type) => handleOnMediaProductTypeChange(media_product_type)}
                    allowedMediaProductTypes={["FEED", "STORY", "REEL"]}
                />
                <MoreOptions
                    onChange={(_preferences) => onPreferencesEdit(postIndex, _preferences)}
                    onCoverEdit={(cover) => onCoverEdit(postIndex, cover)}
                    post={props?.[0] || props}
                    isEditable={isEditable}
                />
            </div>
        )}
        <InstagramFeedPreview {...props} />
        <InstagramStoryPreview {...props} />
    </>)
}

export default InstagramPreview;